import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import Helmet from "react-helmet";
import styled from "styled-components";

import ReadParameter from "./ReadParameter.graphql";

const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebecf0;
    margin-bottom: 16px;

    .title-row {
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: space-between;
    }

    h1 {
        color: #172b4d;
        font-size: 1.35rem;
        font-weight: 700;
        letter-spacing: -0.01em;
        margin: 0;
    }

    .status-badges {
        align-items: center;
        display: flex;
        gap: 6px;
    }

    .badge {
        border-radius: 4px;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        padding: 2px 6px;
        text-transform: uppercase;

        &.deprecated {
            background: #ffebe6;
            color: #bf2600;
        }

        &.active {
            background: #e3fcef;
            color: #006644;
        }
    }

    .meta-row {
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: space-between;
    }

    .actions {
        align-items: center;
        display: flex;
        gap: 8px;
    }
`;

export default function ParameterTitle(props) {
    const { id } = props;

    const readParameter = useQuery(
        gql(ReadParameter),
        {
            variables: {
                id,
            },
        },
    );

    if (readParameter.loading || readParameter.error || !readParameter.data?.parameter) return null;

    const isDeprecated = readParameter.data.parameter.deprecated;
    const nameText = readParameter.data.parameter.name[0]?.text ?? "Untitled Parameter";

    return (
        <StyledHeaderContainer>
            <Helmet>
                <title>P - { nameText } - taxonomy</title>
            </Helmet>
            <div className="title-row">
                <h1>{ nameText }</h1>
                <div className="status-badges">
                    { isDeprecated ? (
                        <span className="badge deprecated">Deprecated</span>
                    ) : (
                        <span className="badge active">Active</span>
                    ) }
                </div>
            </div>
        </StyledHeaderContainer>
    );
}
